class BeforeAfterImage extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector('.before-after__track');
    this.handle = this.querySelector('.before-after__handle');
    this.direction = this.dataset.direction || 'horizontal';
    
    this.isDragging = false;
    
    this.onPointerDown = this.onPointerDown.bind(this);
    this.onPointerMove = this.onPointerMove.bind(this);
    this.onPointerUp = this.onPointerUp.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    
    this.handle.addEventListener('mousedown', this.onPointerDown);
    this.handle.addEventListener('touchstart', this.onPointerDown, { passive: true });
    
    // Accessibility
    this.handle.setAttribute('tabindex', '0');
    this.handle.setAttribute('role', 'slider');
    this.handle.setAttribute('aria-valuenow', this.dataset.initial);
    this.handle.setAttribute('aria-valuemin', '0');
    this.handle.setAttribute('aria-valuemax', '100');
    this.handle.addEventListener('keydown', this.onKeyDown);
  }

  onPointerDown(e) {
    if (e.type === 'mousedown' && e.button !== 0) return;
    this.isDragging = true;
    document.addEventListener('mousemove', this.onPointerMove);
    document.addEventListener('mouseup', this.onPointerUp);
    document.addEventListener('touchmove', this.onPointerMove, { passive: false });
    document.addEventListener('touchend', this.onPointerUp);
    this.classList.add('is-dragging');
  }

  onPointerMove(e) {
    if (!this.isDragging) return;
    
    // Prevent scrolling on touch devices while dragging
    if (e.type === 'touchmove') e.preventDefault();
    
    const clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
    const clientY = e.type.includes('touch') ? e.touches[0].clientY : e.clientY;
    
    const rect = this.track.getBoundingClientRect();
    
    let percent;
    if (this.direction === 'horizontal') {
      let x = clientX - rect.left;
      x = Math.max(0, Math.min(x, rect.width));
      percent = (x / rect.width) * 100;
    } else {
      let y = clientY - rect.top;
      y = Math.max(0, Math.min(y, rect.height));
      percent = (y / rect.height) * 100;
    }
    
    this.updatePercent(percent);
  }

  onPointerUp() {
    this.isDragging = false;
    document.removeEventListener('mousemove', this.onPointerMove);
    document.removeEventListener('mouseup', this.onPointerUp);
    document.removeEventListener('touchmove', this.onPointerMove);
    document.removeEventListener('touchend', this.onPointerUp);
    this.classList.remove('is-dragging');
  }
  
  onKeyDown(e) {
    const step = 5;
    let currentPercent = parseFloat(this.style.getPropertyValue('--percent')) || 50;
    
    if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
      e.preventDefault();
      this.updatePercent(Math.max(0, currentPercent - step));
    } else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
      e.preventDefault();
      this.updatePercent(Math.min(100, currentPercent + step));
    }
  }
  
  updatePercent(percent) {
    this.style.setProperty('--percent', `${percent}%`);
    this.handle.setAttribute('aria-valuenow', Math.round(percent));
  }
}

customElements.define('before-after-image', BeforeAfterImage);
